export const OHL = {
    name: 'DV 106B/1 TS VALjEVO 1 - TS VALjEVO 2',
    voltage: '110',
    regionCode: 'VA',
    stanice: [],
    positionOnPoles: 'Left',
    position: 'S',
    stubovi: [
        { index: 1, name: 'P-02', lat: 44.2816 , lng: 19.9215, sys: 1, portal: true},
        { index: 2, name: '1', lat: 44.2819 , lng: 19.9212, sys: 1},
        { index: 3, name: '2', lat: 44.2837 , lng: 19.9197, sys: 1},
        { index: 4, name: '3', lat: 44.2856 , lng: 19.9181, sys: 1},
        { index: 5, name: '4', lat: 44.288 , lng: 19.9163, sys: 1},
        { index: 6, name: '5', lat: 44.2899 , lng: 19.9147, sys: 1},
        { index: 7, name: '6', lat: 44.2901 , lng: 19.9128, sys: 2},
        { index: 8, name: '7', lat: 44.2902 , lng: 19.9116, sys: 2},
        { index: 9, name: '8', lat: 44.2894 , lng: 19.9079, sys: 2},
        { index: 10, name: '9', lat: 44.2889 , lng: 19.9049, sys: 2},
        { index: 11, name: '10', lat: 44.2882 , lng: 19.9013, sys: 2},
        { index: 12, name: '11', lat: 44.2876 , lng: 19.8985, sys: 2},
        { index: 13, name: '12', lat: 44.2869 , lng: 19.8949, sys: 2},
        { index: 14, name: '13', lat: 44.2864 , lng: 19.8922, sys: 2},
        { index: 15, name: '14', lat: 44.2858 , lng: 19.8893, sys: 2},
        { index: 16, name: '15', lat: 44.2854 , lng: 19.8871, sys: 2},
        { index: 17, name: '16', lat: 44.2857 , lng: 19.8841, sys: 2},
        { index: 18, name: '17', lat: 44.2859 , lng: 19.8819, sys: 2},
        { index: 19, name: '18', lat: 44.2863 , lng: 19.8782, sys: 2},
        { index: 20, name: '19', lat: 44.2866 , lng: 19.8748, sys: 2},
        { index: 21, name: '20', lat: 44.2867 , lng: 19.873, sys: 2},
        { index: 22, name: '21', lat: 44.2872 , lng: 19.8684, sys: 2},
        { index: 23, name: '21A', lat: 44.2873 , lng: 19.8675, sys: 2},
        { index: 24, name: '22', lat: 44.2875 , lng: 19.8656, sys: 2},
        { index: 25, name: '23', lat: 44.2869 , lng: 19.8655, sys: 2},
        { index: 26, name: '24', lat: 44.2853 , lng: 19.8668, sys: 2},
        { index: 27, name: '25', lat: 44.2836 , lng: 19.8683, sys: 2},
        { index: 28, name: '26', lat: 44.2824 , lng: 19.8694, sys: 2},
        { index: 29, name: '27', lat: 44.2798 , lng: 19.8699, sys: 2},
        { index: 30, name: '28', lat: 44.279 , lng: 19.8689, sys: 2},
        { index: 31, name: '29', lat: 44.2784 , lng: 19.8674, sys: 2},
        { index: 32, name: '30', lat: 44.2773 , lng: 19.8674, sys: 2},
        { index: 33, name: '31', lat: 44.2747 , lng: 19.8695, sys: 2},
        { index: 34, name: '32', lat: 44.2744 , lng: 19.8705, sys: 2},
        { index: 35, name: 'P-02', lat: 44.274 , lng: 19.8708, sys: 1, portal: true},
    ],
    rasponi: [
        { name: 'P-02 - 1', position: [{ lat: 44.2816 , lng: 19.9215 }, { lat: 44.2819 , lng: 19.9212 }] },
        { name: '1 - 2', position: [{ lat: 44.2819 , lng: 19.9212 }, { lat: 44.2837 , lng: 19.9197 }] },
        { name: '2 - 3', position: [{ lat: 44.2837 , lng: 19.9197 }, { lat: 44.2856 , lng: 19.9181 }] },
        { name: '3 - 4', position: [{ lat: 44.2856 , lng: 19.9181 }, { lat: 44.288 , lng: 19.9163 }] },
        { name: '4 - 5', position: [{ lat: 44.288 , lng: 19.9163 }, { lat: 44.2899 , lng: 19.9147 }] },
        { name: '5 - 6', position: [{ lat: 44.2899 , lng: 19.9147 }, { lat: 44.2901 , lng: 19.9128 }] },
        { name: '6 - 7', position: [{ lat: 44.2901 , lng: 19.9128 }, { lat: 44.2902 , lng: 19.9116 }] },
        { name: '7 - 8', position: [{ lat: 44.2902 , lng: 19.9116 }, { lat: 44.2894 , lng: 19.9079 }] },
        { name: '8 - 9', position: [{ lat: 44.2894 , lng: 19.9079 }, { lat: 44.2889 , lng: 19.9049 }] },
        { name: '9 - 10', position: [{ lat: 44.2889 , lng: 19.9049 }, { lat: 44.2882 , lng: 19.9013 }] },
        { name: '10 - 11', position: [{ lat: 44.2882 , lng: 19.9013 }, { lat: 44.2876 , lng: 19.8985 }] },
        { name: '11 - 12', position: [{ lat: 44.2876 , lng: 19.8985 }, { lat: 44.2869 , lng: 19.8949 }] },
        { name: '12 - 13', position: [{ lat: 44.2869 , lng: 19.8949 }, { lat: 44.2864 , lng: 19.8922 }] },
        { name: '13 - 14', position: [{ lat: 44.2864 , lng: 19.8922 }, { lat: 44.2858 , lng: 19.8893 }] },
        { name: '14 - 15', position: [{ lat: 44.2858 , lng: 19.8893 }, { lat: 44.2854 , lng: 19.8871 }] },
        { name: '15 - 16', position: [{ lat: 44.2854 , lng: 19.8871 }, { lat: 44.2857 , lng: 19.8841 }] },
        { name: '16 - 17', position: [{ lat: 44.2857 , lng: 19.8841 }, { lat: 44.2859 , lng: 19.8819 }] },
        { name: '17 - 18', position: [{ lat: 44.2859 , lng: 19.8819 }, { lat: 44.2863 , lng: 19.8782 }] },
        { name: '18 - 19', position: [{ lat: 44.2863 , lng: 19.8782 }, { lat: 44.2866 , lng: 19.8748 }] },
        { name: '19 - 20', position: [{ lat: 44.2866 , lng: 19.8748 }, { lat: 44.2867 , lng: 19.873 }] },
        { name: '20 - 21', position: [{ lat: 44.2867 , lng: 19.873 }, { lat: 44.2872 , lng: 19.8684 }] },
        { name: '21 - 21A', position: [{ lat: 44.2872 , lng: 19.8684 }, { lat: 44.2873 , lng: 19.8675 }] },
        { name: '21A - 22', position: [{ lat: 44.2873 , lng: 19.8675 }, { lat: 44.2875 , lng: 19.8656 }] },
        { name: '22 - 23', position: [{ lat: 44.2875 , lng: 19.8656 }, { lat: 44.2869 , lng: 19.8655 }] },
        { name: '23 - 24', position: [{ lat: 44.2869 , lng: 19.8655 }, { lat: 44.2853 , lng: 19.8668 }] },
        { name: '24 - 25', position: [{ lat: 44.2853 , lng: 19.8668 }, { lat: 44.2836 , lng: 19.8683 }] },
        { name: '25 - 26', position: [{ lat: 44.2836 , lng: 19.8683 }, { lat: 44.2824 , lng: 19.8694 }] },
        { name: '26 - 27', position: [{ lat: 44.2824 , lng: 19.8694 }, { lat: 44.2798 , lng: 19.8699 }] },
        { name: '27 - 28', position: [{ lat: 44.2798 , lng: 19.8699 }, { lat: 44.279 , lng: 19.8689 }] },
        { name: '28 - 29', position: [{ lat: 44.279 , lng: 19.8689 }, { lat: 44.2784 , lng: 19.8674 }] },
        { name: '29 - 30', position: [{ lat: 44.2784 , lng: 19.8674 }, { lat: 44.2773 , lng: 19.8674 }] },
        { name: '30 - 31', position: [{ lat: 44.2773 , lng: 19.8674 }, { lat: 44.2747 , lng: 19.8695 }] },
        { name: '31 - 32', position: [{ lat: 44.2747 , lng: 19.8695 }, { lat: 44.2744 , lng: 19.8705 }] },
        { name: '32 - P-02', position: [{ lat: 44.2744 , lng: 19.8705 }, { lat: 44.274 , lng: 19.8708 }] }
    ]
}
